import React, { useState } from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const Onboarding = () => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const nextStep = () => {
    if (step < 3) {
      setStep(step + 1);
    } else {
      navigate('/');
    }
  };
  return <div className="p-4 h-full flex flex-col" data-id="element-2766">
      <div className="flex justify-center mb-4" data-id="element-2767">
        <div className="flex space-x-2" data-id="element-2768">
          {[1, 2, 3].map(i => <div key={i} className={`w-2 h-2 rounded-full ${i === step ? 'bg-gray-800' : 'bg-gray-300'}`} data-id="element-2769"></div>)}
        </div>
      </div>
      {step === 1 && <div className="flex-1 flex flex-col" data-id="element-2770">
          <div className="flex-1 flex flex-col items-center justify-center" data-id="element-2771">
            <div className="w-32 h-32 bg-gray-200 rounded-full flex items-center justify-center border border-dashed border-gray-400 mb-6" data-id="element-2772">
              <span className="text-4xl" data-id="element-2773">👋</span>
            </div>
            <h1 className="text-2xl font-bold text-center mb-2" data-id="element-2774">
              Welcome to Kenyan Communities
            </h1>
            <p className="text-center text-gray-600 mb-8" data-id="element-2775">
              Discover and connect with communities across Kenya
            </p>
          </div>
          <button onClick={nextStep} className="w-full bg-gray-800 text-white rounded-lg py-3 flex items-center justify-center" data-id="element-2776">
            <span data-id="element-2777">Get Started</span>
            <ChevronRightIcon className="w-5 h-5 ml-1" data-id="element-2778" />
          </button>
        </div>}
      {step === 2 && <div className="flex-1 flex flex-col" data-id="element-2779">
          <div className="flex-1" data-id="element-2780">
            <h1 className="text-2xl font-bold mb-4" data-id="element-2781">Tell us about yourself</h1>
            <div className="mb-4" data-id="element-2782">
              <label className="block text-sm font-medium mb-1" data-id="element-2783">
                Your Name
              </label>
              <input type="text" placeholder="Enter your name" className="w-full p-2 border border-gray-300 rounded-lg" data-id="element-2784" />
            </div>
            <div className="mb-4" data-id="element-2785">
              <label className="block text-sm font-medium mb-1" data-id="element-2786">Location</label>
              <select className="w-full p-2 border border-gray-300 rounded-lg" data-id="element-2787">
                <option data-id="element-2788">Select your location</option>
                <option data-id="element-2789">Nairobi</option>
                <option data-id="element-2790">Mombasa</option>
                <option data-id="element-2791">Kisumu</option>
                <option data-id="element-2792">Nakuru</option>
                <option data-id="element-2793">Eldoret</option>
              </select>
            </div>
            <div data-id="element-2794">
              <label className="block text-sm font-medium mb-1" data-id="element-2795">
                Age Group
              </label>
              <div className="grid grid-cols-2 gap-2" data-id="element-2796">
                <button className="border border-gray-300 rounded-lg p-2 text-sm" data-id="element-2797">
                  18-24
                </button>
                <button className="border border-gray-300 rounded-lg p-2 text-sm" data-id="element-2798">
                  25-34
                </button>
                <button className="border border-gray-300 rounded-lg p-2 text-sm" data-id="element-2799">
                  35-44
                </button>
                <button className="border border-gray-300 rounded-lg p-2 text-sm" data-id="element-2800">
                  45+
                </button>
              </div>
            </div>
          </div>
          <button onClick={nextStep} className="w-full bg-gray-800 text-white rounded-lg py-3 flex items-center justify-center mt-4" data-id="element-2801">
            <span data-id="element-2802">Continue</span>
            <ChevronRightIcon className="w-5 h-5 ml-1" data-id="element-2803" />
          </button>
        </div>}
      {step === 3 && <div className="flex-1 flex flex-col" data-id="element-2804">
          <div className="flex-1" data-id="element-2805">
            <h1 className="text-2xl font-bold mb-4" data-id="element-2806">Select your interests</h1>
            <p className="text-sm text-gray-600 mb-4" data-id="element-2807">
              This helps us recommend communities you might like
            </p>
            <div className="grid grid-cols-2 gap-2 mb-4" data-id="element-2808">
              <button className="border border-gray-300 rounded-lg p-3 text-sm flex items-center" data-id="element-2809">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-2" data-id="element-2810">
                  <span data-id="element-2811">🏃</span>
                </div>
                <span data-id="element-2812">Sports & Fitness</span>
              </button>
              <button className="border border-gray-300 rounded-lg p-3 text-sm flex items-center" data-id="element-2813">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-2" data-id="element-2814">
                  <span data-id="element-2815">🎨</span>
                </div>
                <span data-id="element-2816">Arts & Culture</span>
              </button>
              <button className="border border-gray-300 rounded-lg p-3 text-sm flex items-center" data-id="element-2817">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-2" data-id="element-2818">
                  <span data-id="element-2819">💼</span>
                </div>
                <span data-id="element-2820">Professional</span>
              </button>
              <button className="border border-gray-300 rounded-lg p-3 text-sm flex items-center" data-id="element-2821">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-2" data-id="element-2822">
                  <span data-id="element-2823">🎮</span>
                </div>
                <span data-id="element-2824">Hobbies</span>
              </button>
              <button className="border border-gray-300 rounded-lg p-3 text-sm flex items-center" data-id="element-2825">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-2" data-id="element-2826">
                  <span data-id="element-2827">🤲</span>
                </div>
                <span data-id="element-2828">Volunteering</span>
              </button>
              <button className="border border-gray-300 rounded-lg p-3 text-sm flex items-center" data-id="element-2829">
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center mr-2" data-id="element-2830">
                  <span data-id="element-2831">📚</span>
                </div>
                <span data-id="element-2832">Education</span>
              </button>
            </div>
            <button className="w-full border border-dashed border-gray-400 rounded-lg p-3 text-sm" data-id="element-2833">
              + Add more interests
            </button>
          </div>
          <button onClick={nextStep} className="w-full bg-gray-800 text-white rounded-lg py-3 flex items-center justify-center mt-4" data-id="element-2834">
            <span data-id="element-2835">Find Communities</span>
            <ChevronRightIcon className="w-5 h-5 ml-1" data-id="element-2836" />
          </button>
        </div>}
    </div>;
};
export default Onboarding;